import { createEvent } from 'effector';

export const setAccountUuidEV = createEvent<string>();

export const setUserProfile = createEvent<any>();

export const validateUserContact = createEvent<any>();

export const refreshTokenEV = createEvent();

export const changeUserSize = createEvent<any>();
